export default "__VITE_ASSET__R_y4Sn8W__"